import {
  Backdrop,
  Button,
  Fade,
  Grid,
  Snackbar,
  TextField,
  InputLabel,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Modal from "@material-ui/core/Modal";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import MuiAlert from "@material-ui/lab/Alert";
import CloseModalButton from "Admin/Common/CloseModalButton";
import instance from "api/globalaxios";
import { useSnackbar } from "contexts/SnackbarContext";
import FormError from "../Components/FormError";
import useLocations from "../hooks/useLocations";
import { blockInvalidChar } from "features/TempTiacFormV2/ClaimantPage/questions";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { isMSME, isSebi } from "Routes/Routes";
import { createCase, updateCase } from "slices/casesSlice";
import { getCompaniesByGroup } from "slices/companySlice";
import { getRealhost } from "slices/disputeSlice";
import { getCountries } from "slices/profileSlice";
import { isEmailMandatory, isValidPhone } from "../utils";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: "3rem auto",
    height: "80%",
    width: "50%",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
    outline: "none",
    borderRadius: "0.4rem",
    overflowY: "scroll",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
      height: "80%",
      padding: "1rem",
    },
    [theme.breakpoints.down("xs")]: {
      width: "90%",
      height: "80%",
      padding: "0.5rem",
    },
  },
  createlogindetails: {
    fontWeight: "bold",
    fontSize: "24px",
    lineHeight: "23px",
    letterSpacing: "0.6px",
    color: TEXT.secondary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      lineHeight: "18px",
    },
  },
  caseId: {
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "23px",
    letterSpacing: "0.4px",
    color: TEXT.secondary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "16px",
    },
  },
  profileType: {
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "23px",
    letterSpacing: "0.4px",
    color: TEXT.secondary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "16px",
    },
  },
  box: {
    padding: "0.7rem",
  },
  box2: {
    cursor: "pointer",
    padding: "0.7rem",
    "&:hover": {
      backgroundColor: "#EEEEEE",
    },
  },
}));

export default function CreateLoginDetails({
  openmodal,
  handleCloseModal,
  caseId,
  profileType,
  dispute,
  handleCloseModalAfterProfileCreated,
  group,
  casefiles,
  type,
  updateDisputeName,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const isEmailRequired = false;

  useEffect(() => {
    if (isSebi || isMSME) dispatch(getCompaniesByGroup("sebi"));
  }, [dispatch]);

  const [openSnackBar1, setOpenSnackBar1] = useState(false);
  const handleCloseSnackBar1 = () => {
    setOpenSnackBar1(false);
  };
  const [allCountries, setallCountries] = useState([]);
  React.useEffect(() => {
    getCountries().then((res) => {
      let result = [...res];
      result.sort(function (a, b) {
        var nameA = a.name.toUpperCase();
        var nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      setallCountries(result);
    });
  }, []);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const clearError = (key) =>
    setErrors((prev) => (prev[key] ? { ...prev, [key]: "" } : prev));
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [region, setRegion] = useState("");
  const [postal_code, setpostal_code] = useState("");
  const [country, setCountry] = useState("-");
  const [gst_number, setgst_number] = useState("");
  const [pan_number, setpan_number] = useState("");
  const [state_code, setstate_code] = useState("");

  const selectedCountry = allCountries.find((c) => c.id === country);
  const countryCode = selectedCountry ? selectedCountry.code : "";
  const { states, cities } = useLocations(countryCode, state_code);

  const onNameChange = (e) => {
    clearError("name");
    setName(e.target.value);
  };
  const onPhoneChange = (e) => {
    clearError("phone");
    setPhone(e.target.value);
  };
  const onEmailChange = (e) => {
    clearError("email");
    setEmail(e.target.value);
  };
  const onAddressChange = (e) => {
    setAddress(e.target.value);
  };
  const onCityChange = (e) => {
    setCity(e.target.value);
  };
  const onRegionChange = (e) => {
    setRegion(e.target.value);
  };
  const onPostalCodeChange = (e) => {
    setpostal_code(e.target.value);
  };
  const onGstNumberChange = (e) => {
    setgst_number(e.target.value);
  };
  const onPanNumberChange = (e) => {
    setpan_number(e.target.value);
  };

  const assignUser = (profile) => {
    let caseBody = {};
    let c_casefiles = [];
    let r_casefiles = [];
    casefiles.map((item) => {
      if (item.type == "claimant") c_casefiles.push(item);
      else r_casefiles.push(item);
    });
    if (
      type == "claimant" &&
      c_casefiles.length == 1 &&
      c_casefiles[0].profile == null
    ) {
      caseBody = {
        id: c_casefiles[0].id,
        profile: profile.id,
      };
      dispatch(updateCase(caseBody)).then(() => {
        showSnackbar("Assigned", "success");
        updateDisputeName();
        // dispatch(
        //   updateDispute({
        //     id: dispute.id,
        //     rv_claimant_choose_step_complete: true,
        //   })
        // ).then(() => {});
      });
    } else if (
      type == "respondent" &&
      r_casefiles.length == 1 &&
      r_casefiles[0].profile == null
    ) {
      caseBody = {
        id: r_casefiles[0].id,
        profile: profile.id,
      };
      dispatch(updateCase(caseBody)).then(() => {
        showSnackbar("Assigned", "success");
        updateDisputeName();
        // dispatch(
        //   updateDispute({
        //     id: dispute.id,
        //     rv_respondent_choose_step_complete: true,
        //   })
        // ).then(() => {});
      });
    } else {
      caseBody = {
        summary: dispute.description,
        description: dispute.description,
        profile: profile.id,
        dispute: dispute.id,
        type: type,
        lawyer_rv: [],
      };

      dispatch(createCase(caseBody)).then(() => {
        showSnackbar("Assigned", "success");
        updateDisputeName();
      });
    }
  };

  async function createProfile() {
    let data = {
      group: group,
      profile_type: profileType,
      address: address,
      dispute_id: caseId,
      city: city,
      region: region,
      state_code: state_code,
      postal_code: postal_code,
      country: country != "-" ? country : null,
      gst_number: gst_number,
      pan_number: pan_number,
      user: {
        email: email,
        password: "Test@123",
        first_name: name,
        last_name: "",
      },
    };
    if (phone.trim() != "") {
      data["phone_number"] = phone;
    }
    return await instance.post("/customsignup/?host=" + getRealhost(), data, {
      headers: {
        "content-type": "application/json",
      },
    });
  }

  const onSubmit = () => {
    setErrors({});

    if (!name || name.trim() == "") {
      setErrors({ name: "Required" });
    } else {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (email.trim() && !pattern.test(email)) {
        setErrors({ email: "Please enter valid email address." });
      } else if (phone.trim() && !isValidPhone(phone)) {
        setErrors({ phone: "Enter 10-digits phone number" });
      } else {
        createProfile()
          .then((res) => {
            if ((isSebi || isMSME) && profileType == "general_rv") {
              assignUser(res.data);
            }
            handleCloseModalAfterProfileCreated();
          })
          .catch((error) => {
            const data = error?.response?.data;
            console.log(error);
            setErrors({
              email: data?.user?.email ? String(data.user.email[0]) : "",
              phone: data?.phone_number ? String(data.phone_number[0]) : "",
              form: data?.error ? String(data.error) : "",
            });
          });
      }
    }
  };

  const body = (
    <div className={classes.paper}>
      <CloseModalButton onClick={handleCloseModal} />
      <Typography className={classes.createlogindetails}>
        Create Login Details
      </Typography>
      <Box height="0.5rem"></Box>
      <Typography className={classes.caseId}>
        Case ID : {dispute.tiac_custom_dispute_id || dispute.case_number || dispute.id || "---"}
      </Typography>
      <Box height="0.5rem"></Box>
      <Typography className={classes.profileType}>
        Profile Type :{" "}
        {profileType == "general_rv"
          ? "Party"
          : profileType == "arbitrator_rv"
          ? "Arbitrator"
          : profileType == "lawyer_rv"
          ? "Counsel"
          : profileType == "mediator"
          ? "Mediator"
          : "Case Manager"}
      </Typography>
      <Box height="1.5rem"></Box>
      <Grid container justify="space-evenly" spacing={3}>
        <Grid item md={5} sm={10} xs={12}>
          <TextField
            required
            id="name"
            name="name"
            label="Name"
            variant="outlined"
            fullWidth={true}
            value={name}
            error={!!errors.name}
            helperText={errors.name}
            onChange={onNameChange}
          />
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <TextField
            // required
            id="phone"
            name="phone"
            type="number"
            label="Phone Number"
            variant="outlined"
            fullWidth={true}
            value={phone}
            error={!!errors.phone}
            helperText={errors.phone}
            onKeyDown={blockInvalidChar}
            onChange={onPhoneChange}
          />
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <TextField
            required={isEmailRequired}
            id="email"
            name="email"
            label="Email ID"
            variant="outlined"
            fullWidth={true}
            value={email}
            error={!!errors.email}
            helperText={errors.email}
            onChange={onEmailChange}
          />
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <TextField
            id="Apartment and Street"
            name="Apartment and Street"
            label="Apartment and Street"
            variant="outlined"
            fullWidth={true}
            value={address}
            onChange={onAddressChange}
          />
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-country-select-label">Country</InputLabel>
            <Select
              label="Country"
              labelId="demo-country-select-label"
              id="demo-country-select"
              value={country}
              onChange={(e) => {
                setCountry(e.target.value);
                setstate_code("");
                setRegion("");
                setCity("");
              }}
            >
              <MenuItem value={"-"}>---</MenuItem>
              {allCountries.map((country) => {
                return (
                  <MenuItem key={country.id} value={country.id}>
                    {country.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-state-select-label">State</InputLabel>
            <Select
              label="State"
              labelId="demo-state-select-label"
              id="demo-state-select"
              value={state_code}
              onChange={(e) => {
                const code = e.target.value;
                const stateObj = (states || []).find(s => s.iso2 === code);
                setstate_code(code);
                setRegion(stateObj ? stateObj.name : "");
                setCity("");
              }}
            >
              <MenuItem value={""}>---</MenuItem>
              {state_code && !(states || []).some(s => s.iso2 === state_code) && (
                <MenuItem value={state_code}>{region || state_code}</MenuItem>
              )}
              {(states || []).map((s) => (
                <MenuItem key={s.id} value={s.iso2}>
                  {s.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-city-select-label">City</InputLabel>
            <Select
              label="City"
              labelId="demo-city-select-label"
              id="demo-city-select"
              value={city}
              onChange={(e) => {
                setCity(e.target.value);
              }}
            >
              <MenuItem value={""}>---</MenuItem>
              {city && !(cities || []).some(c => c.name.toLowerCase() === city.toLowerCase()) && (
                <MenuItem value={city}>{city}</MenuItem>
              )}
              {(cities || []).map((c) => (
                <MenuItem key={c.id} value={c.name}>
                  {c.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <TextField
            id="postal_code"
            name="postal_code"
            label="Postal Code"
            variant="outlined"
            fullWidth={true}
            value={postal_code}
            onChange={onPostalCodeChange}
          />
        </Grid>
        {isSebi && <Grid item md={5} sm={10} xs={12}>
          <TextField
            id="gst_number"
            name="gst_number"
            label="Gst Number"
            variant="outlined"
            fullWidth={true}
            value={gst_number}
            onChange={onGstNumberChange}
          />
        </Grid>}
        {isSebi && (profileType == "arbitrator_rv" || profileType == "mediator")  && 
        <Grid item md={5} sm={10} xs={12}>
          <TextField
            id="pan_number"
            name="pan_number"
            label="Pan Number"
            variant="outlined"
            fullWidth={true}
            value={pan_number}
            onChange={onPanNumberChange}
          />
        </Grid>}
      </Grid>
      <FormError message={errors.form} />
      <Box height="2rem"></Box>
      <Button
        variant="contained"
        color="primary"
        // style={{ background: "#2F80ED", color: TEXT.onDark }}
        size="large"
        className={classes.bigbtn}
        onClick={onSubmit}
      >
        Create
      </Button>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar1}
        onClose={handleCloseSnackBar1}
        message="Problem in creating guest profile."
        // key={vertical + horizontal}
      >
        <Alert onClose={handleCloseSnackBar1} severity="error">
          Problem in creating guest profile.
        </Alert>
      </Snackbar>
    </div>
  );

  return (
    <Modal
      open={openmodal}
      onClose={handleCloseModal}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      disableEnforceFocus
    >
      <Fade in={openmodal}>{body}</Fade>
    </Modal>
  );
}
